import Icons from 'images/allSvgFinTrack.svg';
import { Switcher, OperationText, BtnArrow } from '../ModalTransaction.styled';
import { useTranslation } from 'react-i18next';

export const SwitchOperation = ({ operation, setOperation }) => {
  const { t } = useTranslation();
  const operations = t('operationsSwitch', { returnObjects: true });
  const currentIndex = operations.findIndex(
    op => op.value === operation?.value
  );

  const handlePrevClick = () => {
    const fromIndex = currentIndex >= 0 ? currentIndex : 0;
    const prevIndex = (fromIndex - 1 + operations.length) % operations.length;
    setOperation(operations[prevIndex]);
  };

  const handleNextClick = () => {
    const fromIndex = currentIndex >= 0 ? currentIndex : 0;
    const nextIndex = (fromIndex + 1) % operations.length;
    setOperation(operations[nextIndex]);
  };

  return (
    <Switcher>
      <BtnArrow type="button" onClick={handlePrevClick}>
        <svg width="24" height="24" fill={'#FF7601'}>
          <use href={`${Icons}#icon-arrow-left`}></use>
        </svg>
      </BtnArrow>
      <OperationText>{operation && operation.label}</OperationText>
      <BtnArrow type="button" onClick={handleNextClick}>
        <svg width="24" height="24" fill={'#FF7601'}>
          <use href={`${Icons}#icon-arrow-right`}></use>
        </svg>
      </BtnArrow>
    </Switcher>
  );
};
